import { useParams } from "react-router-dom"
import CustomerSitesPaginated from "./CustomerSitesPaginated"
import { GetCustomerSitesDocument } from "@hydrologiq/gql-experience/graphql"
import CustomerSiteCreate from "./CustomerSiteCreate"
import { useEffect, useState } from "react"
import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { Section, SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import { PaginationMeta, SortConfig } from "@hydrologiq/shared/types/pagination"
import { DEFAULT_PAGE_SIZE } from "@hydrologiq/shared/config"
function CustomerSites() {
  const { customerId = "" } = useParams()

  // Pagination state
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [sort, setSort] = useState<SortConfig | null>(null)

  // Sites state
  const [sites, setSites] = useState<gqlTypes.CustomerSite[]>([])
  const [pagination, setPagination] = useState<PaginationMeta | undefined>(undefined)

  const { data, loading, error, refetch } = useQueryWithEndpoint<
    gqlTypes.GetCustomerSitesQuery,
    gqlTypes.GetCustomerSitesQueryVariables
  >(
    GetCustomerSitesDocument,
    {
      variables: {
        id: customerId,
        page,
        perPage: pageSize,
        sortBy: sort?.field || undefined,
        sortDirection: sort?.direction || "asc",
      },
    },
    "primary"
  )

  useEffect(() => {
    if (data?.customerSites) {
      // Handle both paginated and non-paginated responses for backward compatibility
      if (Array.isArray(data.customerSites)) {
        // Legacy response format (list of sites)
        setSites(data.customerSites)
        setPagination(undefined)
      } else {
        // New paginated response format
        const response = data.customerSites as any
        setSites(response.data || [])
        setPagination(response.meta)
      }
    }
  }, [data])

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    setPage(1) // Reset to first page when changing page size
  }

  const handleSortChange = (newSort: SortConfig | null) => {
    setSort(newSort)
    setPage(1) // Reset to first page when changing sort
  }

  useEffect(() => {
    refetch()
  }, [])

  return (
    <SectionRoot>
      <Section>
        <CustomerSitesPaginated
          customerId={customerId}
          sites={sites}
          loading={loading}
          error={error?.message ?? null}
          onRetry={refetch}
          pagination={pagination}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          sort={sort}
          onSortChange={handleSortChange}
          headerActions={<CustomerSiteCreate customerId={customerId} onNewSite={() => refetch()} />}
        />
      </Section>
    </SectionRoot>
  )
}
export default CustomerSites
